/**
 * BFF constants (data) for dashboard-sonarprint.
 *
 * @module BFF
 */

/**
 * localStorage key used by the SonarPrint branding for theme persistence.
 * Must match `storageKey` in Branding/sonar-print/Sonar.ts. Injected into the BFF
 * config (`brandingThemeStorageKey`) so preferences sync writes the theme here.
 */
export const BRANDING_THEME_STORAGE_KEY = 'sonarprint-theme';
